import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
  systemPrompt: '',
  messages: [],
  conversationId: null,
  autopilotEnabled: false,
  bookingServices: [],
  selectedBookingService: null,
  enableCallBooking: false,
  humanHandoverPrompt: '',
  spamDetectionPrompt: '',
  followupSchedulingPrompt: '',
  followupMessagePrompt: '',
  followupEnabled: false,
  taggingPrompt: '',
  taggingEnabled: false,
  waitSecondsRangeToRespondContact: { min: 0, max: 0 },
  waitSecondsRangeForMultipleMessages: { min: 0, max: 0 },
  availableTimezones: [],
  timezone: null,
  bookingDurationMinutes: null,
  timeWindow: null,
};

const useSalesBotStore = create(
  devtools(
    (set) => ({
      ...initialState,

      updateSystemPrompt: (prompt) => set({ systemPrompt: prompt }),
      updateHumanHandoverPrompt: (prompt) =>
        set({ humanHandoverPrompt: prompt }),
      updateSpamDetectionPrompt: (prompt) =>
        set({ spamDetectionPrompt: prompt }),
      updateFollowupSchedulingPrompt: (prompt) =>
        set({ followupSchedulingPrompt: prompt }),
      updateFollowupMessagePrompt: (prompt) =>
        set({ followupMessagePrompt: prompt }),
      updateTaggingPrompt: (prompt) => set({ taggingPrompt: prompt }),
      addMessage: (message) =>
        set((state) => ({ messages: [...state.messages, message] })),
      resetMessages: () => set({ messages: [], conversationId: null }),
      setConversationId: (id) => set({ conversationId: id }),
      setAutoPilotEnabled: (value) => set({ autopilotEnabled: value }),
      setBookingServices: (services) => set({ bookingServices: services }),
      setSelectedBookingService: (service) =>
        set({ selectedBookingService: service }),
      setEnableCallBooking: (value) => set({ enableCallBooking: value }),
      setWaitSecondsRangeToRespondContact: (range) =>
        set({ waitSecondsRangeToRespondContact: range }),
      setWaitSecondsRangeForMultipleMessages: (range) =>
        set({ waitSecondsRangeForMultipleMessages: range }),
      setFollowupEnabled: (value) => set({ followupEnabled: value }),
      setTaggingEnabled: (value) => set({ taggingEnabled: value }),
      setAvailableTimezones: (timezones) =>
        set({ availableTimezones: timezones }),
      setTimezone: (timezone) => set({ timezone: timezone }),
      setBookingDurationMinutes: (minutes) =>
        set({ bookingDurationMinutes: minutes }),
      setTimeWindow: (timeWindow) => set({ timeWindow: timeWindow }),
      updateAutopilotSettings: (settings) =>
        set({
          bookingServices: settings.integrations,
          selectedBookingService: settings.booking_service,
          enableCallBooking: settings.enable_call_booking,
          humanHandoverPrompt:
            settings.autopilot_human_handover_criteria_prompt || '',
          spamDetectionPrompt:
            settings.autopilot_spam_detection_criteria_prompt || '',
          followupSchedulingPrompt:
            settings.autopilot_followup_scheduling_prompt || '',
          followupMessagePrompt:
            settings.autopilot_followup_message_prompt || '',
          followupEnabled: settings.followup_enabled,
          taggingPrompt: settings.ai_tagging_prompt || '',
          taggingEnabled: settings.ai_tagging_enabled || false,
          waitSecondsRangeToRespondContact:
            settings.wait_seconds_range_to_respond_contact || {
              min: 0,
              max: 0,
            },
          waitSecondsRangeForMultipleMessages:
            settings.wait_seconds_range_for_multiple_messages || {
              min: 0,
              max: 0,
            },
          availableTimezones: settings.available_timezones || [],
          timezone: settings.timezone || null,
          bookingDurationMinutes: settings.booking_duration_minutes || null,
          timeWindow: settings.time_window || null,
        }),
    }),
    {
      name: 'sales-bot-store',
    }
  )
);
export default useSalesBotStore;
